<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="800" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Tạo tài khoản App và gửi tin nhắn
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <!-- selected student table -->
        <div class="mx-0" v-if="step === 'preview'">
          <div class="d-flex flex-column">
            <div class="mb-4">
              <span><b>Nhóm nhận tin</b></span
              >: {{ students.length }} học sinh
            </div>
            <div class="mb-2">
              Hệ thống sẽ gửi tin nhắn thông báo thông tin tài khoản (để đăng nhập và sử dụng APP) tới các số điện thoại
              đã đăng kí. Vui lòng kiểm tra lại thông tin và bấm
              <span><b>[Gửi]</b></span> để tiếp tục.
            </div>
            <div>
              <span class="error--text">*</span>&nbsp;<b>Lưu ý</b>:<br />
              1. Tài khoản sổ liên lạc phải đang <span><b>Hoạt động</b></span> và có <span><b>SĐT đăng ký</b></span
              ><br />
              2. <span><b>Hình thức sử dụng</b></span> chưa có APP<br />
              3. Nếu gửi đồng thời quá nhiều học sinh, quá trình gửi sẽ tốn thời gian.
            </div>
          </div>

          <v-card class="mt-4" outlined>
            <v-data-table
              :headers="headers"
              :items="students"
              :footer-props="{
                'items-per-page-text': 'Học sinh mỗi trang',
                'items-per-page-all-text': 'Tất cả',
                'items-per-page-options': students.length > 100 ? [5, 15, 30] : [5, 15, -1]
              }"
            >
              <template v-slot:[`footer.page-text`]="items">
                {{ items.pageStart }} - {{ items.pageStop }} trên tổng
                {{ items.itemsLength }}
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <CardStudentName :student="item" link />
              </template>
              <template v-slot:[`item.phone`]="{ item }">
                <v-tooltip max-width="250px" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" class="d-inline-block text-truncate" style="max-width: 150px;">
                      {{ item | getContactBookPhones }}
                    </div>
                  </template>
                  <span>{{ item | getContactBookPhones }}</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.classes`]="{ item }">
                <router-link
                  style="text-decoration: none"
                  :to="'/class/' + (item.currentClass && item.currentClass.id)"
                >
                  <span v-if="item.currentClass">{{ item.currentClass && item.currentClass.title }}</span>
                </router-link>
              </template>
              <template v-slot:[`item.dob`]="{ item }">
                <span>{{ item.dob | ddmmyyyy }}</span>
              </template>
              <template v-slot:[`item.senderMethod`]="{ item }">
                <span>{{ item | getNotificationMethod }}</span>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <v-chip :color="item | getContactBookStatusColor" small class="white--text">{{
                  item | getContactBookStatus
                }}</v-chip>
              </template>
            </v-data-table>
          </v-card>
        </div>

        <!-- error student table -->
        <div class="mx-0" v-else>
          <div class="d-flex flex-column">
            <div>
              Tổng số học sinh đã chọn: <b>{{ students.length }}</b>
            </div>
            <div>
              Học sinh không hợp lệ: <b>{{ students.length - validStudentNo }}</b>
            </div>
            <div>
              Học sinh hợp lệ: <b>{{ validStudentNo }}</b>
            </div>
            <div>
              Tạo tài khoản thành công: <span class="green--text">{{ validStudentNo - errorCreatedUsers.length }}</span>
            </div>
            <div>
              Tạo tài khoản thất bại: <span class="red--text">{{ errorCreatedUsers.length }}</span>
            </div>

            <div class="my-2">
              <h4>Vui lòng xem lịch sử gửi tin nhắn tại trang <b>[Lịch sử gửi tin]</b></h4>
            </div>
          </div>

          <v-card class="mt-4" outlined v-if="errorCreatedUsers.length">
            <v-data-table
              :headers="headers"
              :items="errorCreatedUsers"
              :footer-props="{
                'items-per-page-text': 'Học sinh mỗi trang',
                'items-per-page-all-text': 'Tất cả',
                'items-per-page-options': students.length > 100 ? [5, 15, 30] : [5, 15, -1]
              }"
            >
              <template v-slot:top>
                <div class="px-4">
                  Học sinh tạo lỗi
                </div>
              </template>
              <template v-slot:[`footer.page-text`]="items">
                {{ items.pageStart }} - {{ items.pageStop }} trên tổng
                {{ items.itemsLength }}
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <CardStudentName :student="item" link />
              </template>
              <template v-slot:[`item.phone`]="{ item }">
                <v-tooltip max-width="250px" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" class="d-inline-block text-truncate" style="max-width: 150px;">
                      {{ item | getContactBookPhones }}
                    </div>
                  </template>
                  <span>{{ item | getContactBookPhones }}</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.classes`]="{ item }">
                <router-link
                  style="text-decoration: none"
                  :to="'/class/' + (item.currentClass && item.currentClass.id)"
                >
                  <span v-if="item.currentClass">{{ item.currentClass && item.currentClass.title }}</span>
                </router-link>
              </template>
              <template v-slot:[`item.dob`]="{ item }">
                <span>{{ item.dob | ddmmyyyy }}</span>
              </template>
              <template v-slot:[`item.senderMethod`]="{ item }">
                <span>{{ item | getNotificationMethod }}</span>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <v-chip :color="item | getContactBookStatusColor" small class="white--text">{{
                  item | getContactBookStatus
                }}</v-chip>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn v-if="step === 'preview'" class="ma-2 px-4" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="step === 'preview'" class="ma-2" dark depressed color="primary" @click="send">Gửi </v-btn>
        <v-btn v-if="step === 'noti'" class="ma-2" dark depressed @click="cancel" color="primary">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'

export default {
  components: { CardStudentName },
  props: {
    state: Boolean,
    students: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'Học sinh',
          value: 'name',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Ngày sinh',
          value: 'dob',
          align: 'left',
          sortable: false,
          show: true
        },
        { text: 'Lớp', value: 'classes', align: 'left', sortable: false, show: true },
        {
          text: 'Hình thức sử dụng',
          value: 'senderMethod',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'SĐT đăng ký',
          value: 'phone',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Trạng thái',
          value: 'status',
          align: 'left',
          sortable: false,
          show: true
        }
      ],
      dialog: false,
      step: 'preview',
      errorCreatedUsers: [],
      successCreatedUsers: [],
      validStudentNo: 0
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('role', ['roleIdByName'])
  },
  methods: {
    ...mapActions('ContactBook', ['createUser', 'updateContactBook']),
    async send() {
      this.$loading.active = true
      this.errorCreatedUsers = []
      const filteredStudents = this.students.filter(
        s =>
          s.contactBook &&
          !s.contactBook.isApp &&
          s.contactBook.status === 'active' &&
          s.contactBook.phones &&
          (!s.user || !s.user.id)
      )
      this.validStudentNo = filteredStudents.length
      // Create app account and send password sms
      for (const student of filteredStudents) {
        let user = {}
        try {
          await this.updateContactBook({
            id: student.contactBook.id,
            isApp: true
          })

          const params = {
            student,
            password: this.$utils.autoGeneratePassword(),
            role: this.roleIdByName('Student'),
            staffId: this.profile.id
          }
          user = await this.createUser(params)
        } catch (error) {
          this.errorCreatedUsers.push(student)
          if (user.id) await this.removeUser(user.id)
        }
      }
      this.step = 'noti'
      this.$loading.active = false
      this.$emit('done')
    },
    cancel() {
      this.reset()
      this.dialog = false
    },
    reset() {}
  },

  watch: {
    state(state) {
      this.step = 'preview'
      this.dialog = true
    }
  }
}
</script>

<style scoped></style>
